import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { OrganizationService } from "../../../../services/ClientService";

import { useCallback } from "react";
import { Checkbox } from "@material-ui/core";

export default function OrganizationProfile(
    this: any,
    {
        organization,
    }: {
        organization: APIModels.Organization;
    }
) {
    const [updatedOrganization, setUpdatedOrganization] =
        useState(organization);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedOrganization(organization);
    }, [organization]);

    const onSaveClick = () => {
        setSaving(true);
        OrganizationService.add({
            body: updatedOrganization,
        }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    organization = { ...resp.data };
                } else {
                    setErrorMessage("An error has occurred");
                }
            },
            (error) => {
                setSaving(false);
                setErrorMessage("An error occurred.");
            }
        );
    };

    return (
        <>
            <div className="card text-left">
                <div className="card-body">
                    <h4 className="mb-3 bg-light p-2">Organization Profile</h4>
                    <div className="row mb-3">
                        <div className="col-sm-4">
                            <label
                                htmlFor="txtProfileFirstName"
                                className="form-label"
                            >
                                Organization Name
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtProfileOrganizationName"
                                    placeholder="OrganizationName"
                                    aria-describedby="inputGroupPrepend"
                                    value={updatedOrganization.name}
                                    onChange={(event) =>
                                        setUpdatedOrganization({
                                            ...updatedOrganization,
                                            name: event.currentTarget.value,
                                        })
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid organization name.
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-8">
                            <div className="" style={{ marginLeft: "100px" }}>
                                <label
                                    htmlFor="txtProfileFirstName"
                                    className="form-label"
                                >
                                    Features
                                </label>
                                <div className="row checkbox-group required">
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                checked={
                                                    updatedOrganization.dfs ??
                                                    false
                                                }
                                                id="ckDFS"
                                                onChange={(e) =>
                                                    setUpdatedOrganization({
                                                        ...updatedOrganization,
                                                        dfs: e.currentTarget
                                                            .checked,
                                                    })
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="ckDFS"
                                            >
                                                DFS
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="ckOrders"
                                                checked={
                                                    updatedOrganization.orders ??
                                                    false
                                                }
                                                onChange={(e) =>
                                                    setUpdatedOrganization({
                                                        ...updatedOrganization,
                                                        orders: e.currentTarget
                                                            .checked,
                                                    })
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="ckOrders"
                                            >
                                                Orders
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="ckallowTemplates"
                                                checked={
                                                    updatedOrganization.allowTemplates ??
                                                    false
                                                }
                                                onChange={(e) =>
                                                    setUpdatedOrganization({
                                                        ...updatedOrganization,
                                                        allowTemplates:
                                                            e.currentTarget
                                                                .checked,
                                                    })
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="ckBatch"
                                            >
                                                Allow Templates
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="ckBatch"
                                                checked={
                                                    updatedOrganization.batch ??
                                                    false
                                                }
                                                onChange={(e) =>
                                                    setUpdatedOrganization({
                                                        ...updatedOrganization,
                                                        batch: e.currentTarget
                                                            .checked,
                                                    })
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="ckBatch"
                                            >
                                                Batch
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="ckTemplateOnly"
                                                checked={
                                                    updatedOrganization.templateOnly ??
                                                    false
                                                }
                                                onChange={(e) =>
                                                    setUpdatedOrganization({
                                                        ...updatedOrganization,
                                                        templateOnly:
                                                            e.currentTarget
                                                                .checked,
                                                    })
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="ckBatch"
                                            >
                                                Template Only
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="ckallowTemplates"
                                                checked={
                                                    updatedOrganization.fileDrop ??
                                                    false
                                                }
                                                onChange={(e) =>
                                                    setUpdatedOrganization({
                                                        ...updatedOrganization,
                                                        fileDrop:
                                                            e.currentTarget
                                                                .checked,
                                                    })
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="ckBatch"
                                            >
                                                File Drop
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-end">
                        {saving ? (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="button"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Saving...
                            </button>
                        ) : (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="submit"
                                onClick={onSaveClick}
                            >
                                <i className="mdi mdi-content-save me-1"></i>
                                Save
                            </button>
                        )}
                        <div>{errorMessage}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
